import { generateFingerprint } from '@/utils/Fingerprint';
import { getUserIP } from '@/utils/getIP';

export const fetchTrackingData = async (fingerprintHash: string) => {
  try {
    // Make the GET request to fetch data for the given fingerprint
    const response = await fetch(`/web-tools/de/app-api/usertracking?fingerprintHash=${fingerprintHash}`);

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const data = await response.json();

    return data; // return the data to use it later, e.g., setting state
  } catch (error) {
    // console.error('Error fetching tracking data:', error);
    console.error('Error fetching user data');
    return null; // Return null instead of exposing error details

  }
};
export const createTrackingData = async (fingerprintHash: string, ip: string) => {
  try {
    // Prepare the data to send in the POST request
    const body = JSON.stringify({ fingerprint: fingerprintHash, ip: ip });

    // Make the POST request to create a new tracking record
    const response = await fetch('/web-tools/de/app-api/usertracking', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Unknown error');
    }

    const data = await response.json();
    return data; // return the response for further use, e.g., setting state
  } catch (error) {
    // console.error('Error creating tracking data:', error);
    console.error('Error creating user data:');
  }
};

export const updateToolLimitApi = async (fingerprintHash: string, toolName: string) => {
  try {
    const response = await fetch('/web-tools/de/app-api/usertracking', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        fingerprintHash,
        toolName,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Error updating tool limit');
    }

  } catch (error) {
    // console.error('Error updating tool limit:', error);
    console.error('Error updating tool limit');
  }
};


export const checkFingerprintHash = async (
  fingerprintHash: string,
  toolName: string, // Added toolName parameter
  setCounter: (counter: number) => void
) => {
  try {
    const data = await fetchTrackingData(fingerprintHash);
    // Check if the data and the specific tool limit field exist
    if (data && data[toolName] !== undefined) {
      setCounter(data[toolName]); // Set the counter to the specific tool limit
    } else {
      // If not found, create a new entry in the database
      const ip = await getUserIP(); // Fetch IP address directly here
      const newRowData = await createTrackingData(fingerprintHash, ip);

      if (newRowData && newRowData[toolName] !== undefined) {

        setCounter(newRowData[toolName]); // Set the counter to the tool limit from the new row
      } else {
        console.warn(`Error creating a new entry or fetching ${toolName}`);
      }
    }
  } catch (error) {
    // console.error('Error checking fingerprintHash:', error);
    console.warn('Error checking user data:');
  }
};



// Function to initialize tracking (e.g., from a component mount)
export const initializeTracking = async (
  fingerprintHash: string,
  toolName: string, // Added toolName parameter
  setCounter: (counter: number) => void
) => {
  await checkFingerprintHash(fingerprintHash,toolName, setCounter); // Check or create the fingerprint data
};
